module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "illustration-ct1"
    }
  }), _vm._v("ILLUSTRATIONS ")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/fm1"
    }
  }, [_vm._v("Life Springs Anew")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface_a"
    }
  }, [_vm._v("The Empty Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#img1"
    }
  }, [_vm._v("The Color of Violet")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part1a"
    }
  }, [_vm._v("Spirit Search")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tree Sees Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Promise of Riches")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beast within the Beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#img3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Was Right")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Light of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#img4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Is What You Make It")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23#img5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gift of Every Breath")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24#img6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wopstegwan you Kiyew")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24#img7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strong Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch25#img8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Master")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Little Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch31#img9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch32b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Wisdom Goes to Die")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/conclusion#img10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Philosopher Smokes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6861e25e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustration.vue
// module id = 75
// module chunks = 0